import { jsxs as m, Fragment as M, jsx as e } from "react/jsx-runtime.js";
import { useState as N, useEffect as F, createElement as p } from "react";
function w({
  children: n,
  renderTrigger: t,
  position: r = "bottom center",
  trigger: d = "hover",
  arrow: l = !0,
  onOpen: s
}) {
  const [u, _] = N(!1), [o, a] = N(null);
  F(() => {
    let f = !0;
    return _(!0), import("reactjs-popup").then((g) => {
      f && a(() => g.default);
    }), () => {
      f = !1;
    };
  }, []);
  const i = () => /* @__PURE__ */ e("div", { className: "gd-nav-menu_popup_trigger", children: t() }), h = () => /* @__PURE__ */ e("div", { className: "gd-nav-menu_popup_content", children: n });
  return !u || !o ? /* @__PURE__ */ m(M, { children: [
    i(),
    /* @__PURE__ */ e("div", { className: "gd-nav-menu_popup_content_extra_box", children: h() })
  ] }) : (
    // @ts-ignore
    /* @__PURE__ */ e(
      o,
      {
        className: `gd-nav-menu_popup gd-nav-menu_popup_${r}`,
        trigger: i,
        position: r,
        on: d,
        arrow: l,
        onOpen: s,
        children: /* @__PURE__ */ e("div", { className: "gd-nav-menu_popup_content", children: n })
      }
    )
  );
}
const $ = (n) => {
  var l;
  const t = (l = n.pits) == null ? void 0 : l.find((s) => s.mark.includes("-media-info")), r = t == null ? void 0 : t.materials.map((s) => s.material), [d] = N(r);
  return {
    mediaData: d
  };
}, A = (n, t) => {
  const r = new CustomEvent(n, {
    detail: t,
    bubbles: !0,
    composed: !0
  });
  window.dispatchEvent(r);
}, L = (n) => {
  const t = /* @__PURE__ */ new Set();
  return {
    dispatch: (r) => A(n, r),
    addListener: (r) => {
      t.has(r) || (t.add(r), window.addEventListener(n, r));
    },
    removeListener: (r) => {
      t.has(r) && (window.removeEventListener(n, r), t.delete(r));
    }
  };
}, Q = "@gdesign/footer/tracker-click", U = "@gdesign/footer/tracker-export", {
  dispatch: S,
  addListener: Fn,
  removeListener: Ln
} = L(Q), {
  dispatch: Sn,
  addListener: Bn,
  removeListener: $n
} = L(U), D = "_brandInfo_ox3y2_2", j = "_brandInfo__logo_ox3y2_6", G = "_brandInfo__logo_hb_ox3y2_9", H = "_brandInfo__media_info_ox3y2_12", K = "_brandInfo__qrcode_box_ox3y2_18", O = "_brandInfo__qrcode_ox3y2_18", P = "_brandInfo__icon_ox3y2_26", I = {
  brandInfo: D,
  brandInfo__logo: j,
  brandInfo__logo_hb: G,
  brandInfo__media_info: H,
  brandInfo__qrcode_box: K,
  brandInfo__qrcode: O,
  brandInfo__icon: P
};
function V(n) {
  const { portal: t } = n, { mediaData: r } = $(n.dataSource), d = (_) => {
    _.link && (window.open(_.link, "_blank"), S({
      button_name: _.text
    }));
  }, l = () => /* @__PURE__ */ e(
    "img",
    {
      className: I.brandInfo__logo,
      src: "https://cdn.dancf.com/assets/2025/framework/svg/gd-logo.svg",
      alt: "gaoding-logo"
    }
  ), s = () => /* @__PURE__ */ e(
    "img",
    {
      className: I.brandInfo__logo_hb,
      src: "https://cdn.dancf.com/assets/2025/framework/svg/hb-logo.svg",
      alt: "huaban-logo"
    }
  ), u = () => {
    if (!(r != null && r.length))
      return;
    const _ = (o, a) => /* @__PURE__ */ e(
      "img",
      {
        onClick: () => d(o),
        className: I.brandInfo__icon,
        src: o.icon,
        alt: "gaoding-logo"
      },
      a
    );
    return /* @__PURE__ */ e("div", { className: I.brandInfo__media_info, children: r.map((o, a) => o.qrcodeUrl ? /* @__PURE__ */ e(
      w,
      {
        trigger: "hover",
        arrow: !1,
        position: "bottom left",
        renderTrigger: () => _(o),
        children: /* @__PURE__ */ e("div", { className: I.brandInfo__qrcode_box, children: o.qrcodeUrl ? /* @__PURE__ */ e(
          "img",
          {
            className: I.brandInfo__qrcode,
            src: o.qrcodeUrl,
            alt: o.text
          }
        ) : null })
      },
      a
    ) : _(o, a)) });
  };
  return /* @__PURE__ */ m("div", { className: I.brandInfo, children: [
    /* @__PURE__ */ e("a", { href: "/", children: t === "huaban" ? s() : l() }),
    u()
  ] });
}
const W = "_navMenu_1n6of_1", X = "_navMenu__item_list_1n6of_9", Y = "_navMenu__item_1n6of_9", z = "_navMenu__item_title_1n6of_28", J = "_navMenu__item_active_1n6of_44", Z = "_navMenu__item_content_box_1n6of_50", R = "_navMenu__item_close_1n6of_53", b = {
  navMenu: W,
  navMenu__item_list: X,
  navMenu__item: Y,
  navMenu__item_title: z,
  navMenu__item_active: J,
  navMenu__item_content_box: Z,
  navMenu__item_close: R
}, nn = (n) => {
  var l;
  const t = (l = n.pits) == null ? void 0 : l.find((s) => s.mark.includes("-nav-menu")), r = t == null ? void 0 : t.materials.map(
    (s) => "category" in s.material ? s.material.category : []
  ), [d] = N(r);
  return {
    navMenuData: d
  };
}, B = (n, t) => Array.isArray(n) ? (n || []).some((r) => B(r, t)) : n instanceof RegExp ? n.test(t) : n === "*" || n.endsWith("*") && t.startsWith(n.slice(0, -1)) ? !0 : n === t, en = "_navMenuItemName_p1s2m_1", tn = "_navMenuItemName__a_p1s2m_17", rn = "_navMenuItemName__icon_p1s2m_25", y = {
  navMenuItemName: en,
  navMenuItemName__a: tn,
  navMenuItemName__icon: rn
};
function C(n) {
  const t = () => {
    S({
      button_name: n.name
    });
  }, r = () => n != null && n.link ? /* @__PURE__ */ e(
    "a",
    {
      href: n.link,
      target: "_blank",
      rel: "nofollow",
      className: y.navMenuItemName__a,
      children: n.name
    }
  ) : /* @__PURE__ */ e("span", { children: n.name });
  return /* @__PURE__ */ m("div", { className: y.navMenuItemName, onClick: () => t(), children: [
    r(),
    n.icon ? /* @__PURE__ */ e("img", { className: y.navMenuItemName__icon, src: n.icon }) : null
  ] });
}
const on = "_qrcodeContent_1k2or_1", an = "_qrcodeContent__qrcode_1k2or_4", T = {
  qrcodeContent: on,
  qrcodeContent__qrcode: an
};
function _n(n) {
  const t = n.qrcode, [r, d] = N({}), l = () => {
    const _ = t == null ? void 0 : t.find((i) => {
      if (i.pageUrl) {
        const h = new URL(i.pageUrl);
        return B(h.pathname, window.location.pathname);
      }
      return null;
    }), o = t == null ? void 0 : t.find((i) => !i.pageUrl);
    d(_ || o);
  };
  F(() => {
    l();
  }, []);
  const s = () => {
    const _ = { ...n, link: r.link };
    return /* @__PURE__ */ e(C, { ..._ });
  }, u = () => r ? /* @__PURE__ */ e("div", { className: T.qrcodeContent, children: /* @__PURE__ */ e(
    "img",
    {
      className: T.qrcodeContent__qrcode,
      src: r.qrcodeUrl,
      alt: n.name
    }
  ) }) : null;
  return r ? /* @__PURE__ */ e(w, { renderTrigger: s, position: "top left", trigger: "hover", children: u() }) : null;
}
const sn = "_submenu__trigger_1uq9y_1", cn = "_submenu__box_1uq9y_4", ln = "_submenu__content_1uq9y_9", dn = "_submenu__content__a_1uq9y_17", k = {
  submenu__trigger: sn,
  submenu__box: cn,
  submenu__content: ln,
  submenu__content__a: dn
};
function un(n) {
  var d;
  const t = () => /* @__PURE__ */ e(C, { ...n }), r = () => {
    var _, o;
    const l = (_ = n.submenu) == null ? void 0 : _.filter((a, i) => i % 2 !== 0), s = (o = n.submenu) == null ? void 0 : o.filter((a, i) => i % 2 === 0), u = (a, i) => /* @__PURE__ */ e(
      "a",
      {
        href: a.link,
        className: k.submenu__content__a,
        target: "_blank",
        rel: "nofollow",
        children: a.name
      },
      i
    );
    return /* @__PURE__ */ e("div", { className: k.submenu__box, children: /* @__PURE__ */ m("div", { className: k.submenu__content, children: [
      /* @__PURE__ */ e("div", { className: k.submenu__content__even, children: s == null ? void 0 : s.map((a, i) => u(a, i)) }),
      /* @__PURE__ */ e("div", { className: k.submenu__content__odd, children: l == null ? void 0 : l.map((a, i) => u(a, i)) })
    ] }) });
  };
  return (d = n == null ? void 0 : n.submenu) != null && d.length ? /* @__PURE__ */ e(w, { renderTrigger: t, position: "top left", trigger: "hover", arrow: !0, children: r() }) : t();
}
const mn = "_seonavTrigger_h4opy_1", fn = "_seonavBox_h4opy_4", gn = "_seonavContent_h4opy_9", vn = "_seonavContent__a_h4opy_17", v = {
  seonavTrigger: mn,
  seonavBox: fn,
  seonavContent: gn,
  seonavContent__a: vn
};
function hn(n) {
  var d;
  const t = () => /* @__PURE__ */ e(C, { ...n.menuItem }), r = () => {
    var _, o;
    const l = (_ = n.internalLinks) == null ? void 0 : _.filter((a, i) => i % 2 !== 0), s = (o = n.internalLinks) == null ? void 0 : o.filter((a, i) => i % 2 === 0), u = (a, i) => /* @__PURE__ */ e("a", { href: a.url, className: v.seonavContent__a, target: "_blank", children: a.keyword }, i);
    return /* @__PURE__ */ e("div", { className: v.seonavBox, children: /* @__PURE__ */ m("div", { className: v.seonavContent, children: [
      /* @__PURE__ */ e("div", { className: v.seonavContent__even, children: s == null ? void 0 : s.map((a, i) => u(a, i)) }),
      /* @__PURE__ */ e("div", { className: v.seonavContent__odd, children: l == null ? void 0 : l.map((a, i) => u(a, i)) })
    ] }) });
  };
  return (d = n == null ? void 0 : n.internalLinks) != null && d.length ? /* @__PURE__ */ e(w, { renderTrigger: t, position: "top left", trigger: "hover", arrow: !0, children: r() }) : null;
}
function In(n) {
  var s, u;
  const { seoTopics: t } = n, r = (s = t == null ? void 0 : t.children) == null ? void 0 : s.find(
    (_) => _.category_name === n.menuItem.name
  ), d = () => /* @__PURE__ */ e(C, { ...n.menuItem }), l = () => {
    var i, h;
    const _ = (i = r == null ? void 0 : r.children) == null ? void 0 : i.filter((f, g) => g % 2 !== 0), o = (h = r == null ? void 0 : r.children) == null ? void 0 : h.filter((f, g) => g % 2 === 0), a = (f, g) => {
      var q, E;
      return /* @__PURE__ */ e(
        "a",
        {
          href: (q = f == null ? void 0 : f.seo) == null ? void 0 : q.alts,
          className: v.seonavContent__a,
          target: "_blank",
          rel: (E = f == null ? void 0 : f.seo) != null && E.nofollow ? "nofollow" : "",
          children: f.category_name
        },
        g
      );
    };
    return /* @__PURE__ */ e("div", { className: v.seonavBox, children: /* @__PURE__ */ m("div", { className: v.seonavContent, children: [
      /* @__PURE__ */ e("div", { className: v.seonavContent__even, children: o == null ? void 0 : o.map((f, g) => a(f, g)) }),
      /* @__PURE__ */ e("div", { className: v.seonavContent__odd, children: _ == null ? void 0 : _.map((f, g) => a(f, g)) })
    ] }) });
  };
  return (u = r == null ? void 0 : r.children) != null && u.length ? /* @__PURE__ */ e(w, { renderTrigger: d, position: "top left", trigger: "hover", arrow: !0, children: l() }) : null;
}
function bn(n) {
  var t, r;
  if (((t = n.menuItem) == null ? void 0 : t.seonav) === "recommend")
    return /* @__PURE__ */ e(hn, { menuItem: n.menuItem, internalLinks: n.internalLinks });
  if (((r = n.menuItem) == null ? void 0 : r.seonav) === "navigation")
    return /* @__PURE__ */ e(In, { menuItem: n.menuItem, seoTopics: n.seoTopics });
}
function Nn(n) {
  const { navMenuData: t } = nn(n.dataSource), [r, d] = N(""), l = (_, o) => {
    d(`${_}-${o}`);
  }, s = (_) => /* @__PURE__ */ e(M, { children: _.map((o, a) => o.type === "qrcode" ? /* @__PURE__ */ p(_n, { ...o, key: a }) : o.type === "submenu" ? /* @__PURE__ */ p(un, { ...o, key: a }) : o.type === "seonav" ? /* @__PURE__ */ e(
    bn,
    {
      menuItem: o,
      internalLinks: n.dataSource.internalLinks || [],
      seoTopics: n.dataSource.seoTopics
    },
    a
  ) : /* @__PURE__ */ p(C, { ...o, key: a })) }), u = (_, o) => /* @__PURE__ */ e("div", { className: b.navMenu__item_list, children: _.map((a, i) => {
    const h = r === `${o}-${i}` ? "active" : "close";
    return /* @__PURE__ */ m(
      "div",
      {
        className: b.navMenu__item + " " + b["navMenu__item_" + h],
        children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: b.navMenu__item_title,
              onClick: () => l(o, i),
              children: a.title
            }
          ),
          /* @__PURE__ */ e("div", { className: b.navMenu__item_content_box, children: s(a.menu) })
        ]
      },
      i
    );
  }) }, o);
  return /* @__PURE__ */ e("div", { className: b.navMenu, children: t == null ? void 0 : t.map((_, o) => u(_, o)) });
}
const kn = "_filingInfo_ee9tb_1", wn = "_filingInfo__span_ee9tb_15", Cn = "_filingInfo__a_ee9tb_18", Mn = "_filingInfo__item_separator_ee9tb_21", c = {
  filingInfo: kn,
  filingInfo__span: wn,
  filingInfo__a: Cn,
  filingInfo__item_separator: Mn
};
function pn(n) {
  const t = n.dataSource.appReleases, r = (/* @__PURE__ */ new Date()).getFullYear(), d = () => {
    var u, _;
    return /* @__PURE__ */ e(M, { children: t && /* @__PURE__ */ m(M, { children: [
      /* @__PURE__ */ e("span", { className: c.filingInfo__item_separator }),
      /* @__PURE__ */ m("span", { className: c.filingInfo__span, children: [
        "版本号 iOS ",
        ((u = t == null ? void 0 : t.ios) == null ? void 0 : u.version) || "5.1.1",
        " Android",
        " ",
        ((_ = t == null ? void 0 : t.android) == null ? void 0 : _.version) || "5.1.1"
      ] })
    ] }) });
  }, l = () => /* @__PURE__ */ m("div", { className: c.filingInfoBox, children: [
    /* @__PURE__ */ m("div", { className: c.filingInfoItem, children: [
      /* @__PURE__ */ e(
        "a",
        {
          href: "https://beian.miit.gov.cn/#/Integrated/index",
          rel: "nofollow",
          target: "_blank",
          className: c.filingInfo__a,
          children: "闽ICP备18003982号-2"
        }
      ),
      /* @__PURE__ */ e("span", { className: c.filingInfo__item_separator }),
      /* @__PURE__ */ e(
        "a",
        {
          href: "https://www.cac.gov.cn/2024-04/11/c_1714509267496697.htm",
          rel: "nofollow",
          target: "_blank",
          className: c.filingInfo__a,
          children: "网信算备350203997384601240023号"
        }
      ),
      /* @__PURE__ */ e("span", { className: c.filingInfo__item_separator }),
      /* @__PURE__ */ e(
        "a",
        {
          href: "https://www.cac.gov.cn/2024-04/11/c_1714509267496697.htm",
          rel: "nofollow",
          target: "_blank",
          className: c.filingInfo__a,
          children: "网信算备350203997384601240015号"
        }
      ),
      /* @__PURE__ */ e("span", { className: c.filingInfo__item_separator }),
      /* @__PURE__ */ e(
        "a",
        {
          href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020602001758",
          rel: "nofollow",
          target: "_blank",
          className: c.filingInfo__a,
          children: "闽公网安备 35020602001758"
        }
      )
    ] }),
    /* @__PURE__ */ m("div", { className: c.filingInfoItem, children: [
      /* @__PURE__ */ e("span", { className: c.filingInfo__span, children: "生成式人工智能服务管理暂行办法备案 Fujian-GaoDingAI-202501080003" }),
      /* @__PURE__ */ e("span", { className: c.filingInfo__item_separator }),
      /* @__PURE__ */ m("span", { className: c.filingInfo__span, children: [
        "© 2017 - ",
        r,
        " 稿定（厦门）科技有限公司"
      ] }),
      d()
    ] })
  ] }), s = () => /* @__PURE__ */ m("div", { className: c.filingInfoBox, children: [
    /* @__PURE__ */ m("div", { className: c.filingInfoItem, children: [
      /* @__PURE__ */ e(
        "a",
        {
          href: "https://beian.miit.gov.cn/#/Integrated/index",
          rel: "nofollow",
          target: "_blank",
          className: c.filingInfo__a,
          children: "闽ICP备2021013850号-2"
        }
      ),
      /* @__PURE__ */ e("span", { className: c.filingInfo__item_separator }),
      /* @__PURE__ */ e(
        "a",
        {
          href: "https://www.cac.gov.cn/2024-04/11/c_1714509267496697.htm",
          rel: "nofollow",
          target: "_blank",
          className: c.filingInfo__a,
          children: "网信算备 350203997384601240023号"
        }
      ),
      /* @__PURE__ */ e("span", { className: c.filingInfo__item_separator }),
      /* @__PURE__ */ e(
        "a",
        {
          href: "https://www.cac.gov.cn/2024-04/11/c_1714509267496697.htm",
          rel: "nofollow",
          target: "_blank",
          className: c.filingInfo__a,
          children: "网信算备 350203997384601240015号"
        }
      ),
      /* @__PURE__ */ e("span", { className: c.filingInfo__item_separator }),
      /* @__PURE__ */ e(
        "a",
        {
          href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020602002342",
          rel: "nofollow",
          target: "_blank",
          className: c.filingInfo__a,
          children: "闽公网安备 35020602002342"
        }
      )
    ] }),
    /* @__PURE__ */ m("div", { className: c.filingInfoItem, children: [
      /* @__PURE__ */ e("span", { className: c.filingInfo__span, children: "生成式人工智能服务管理暂行办法备案 Fujian-GaoDingAI-202501080003" }),
      /* @__PURE__ */ e("span", { className: c.filingInfo__item_separator }),
      /* @__PURE__ */ m("span", { className: c.filingInfo__span, children: [
        "©Huaban 2011- ",
        r,
        " 稿定（厦门）信息服务有限公司"
      ] }),
      d()
    ] })
  ] });
  return /* @__PURE__ */ e("div", { className: c.filingInfo, children: n.portal === "huaban" ? s() : l() });
}
const yn = "_footerFrame_1uduo_1", xn = "_footerFrameTop_1uduo_18", qn = "_footerFrameBottom_1uduo_36", x = {
  footerFrame: yn,
  footerFrameTop: xn,
  footerFrameBottom: qn
};
function An(n) {
  return /* @__PURE__ */ m("footer", { className: x.footerFrame, children: [
    /* @__PURE__ */ m("div", { className: x.footerFrameTop, children: [
      /* @__PURE__ */ e(V, { portal: n.portal, dataSource: n.dataSource }),
      /* @__PURE__ */ e(Nn, { portal: n.portal, dataSource: n.dataSource })
    ] }),
    /* @__PURE__ */ e("div", { className: x.footerFrameBottom, children: /* @__PURE__ */ e(pn, { dataSource: n.dataSource, portal: n.portal }) })
  ] });
}
export {
  An as Footer,
  Ln as offTrackerClickEventListener,
  Fn as onTrackerClickEventListener,
  Bn as onTrackerExportEventListener
};
